import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateYearlyCremationComparisonReport } from '../../../services/report/ReportService';

class YearlyCremationComparisonReport extends SpecificationReportPage {

  getFields() {
    // two years compared against each other, not a span of years
    return ['twoYears'];
  }

  getService() {
    return generateYearlyCremationComparisonReport;
  }

  getFileName() {
    return "1B-uporedni-godisnji-kremacije";
  }

  getPageTitle() {
    return strings.specificationReports.yearlyCremationComparisonTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(YearlyCremationComparisonReport)));
